module.exports = __webpack_public_path__ + "static/media/HOME-image9.f15fbd17.png";